export default __webpack_public_path__ + "static/media/GY.c4ccbbc9.svg";